export default __webpack_public_path__ + "static/media/icn_close.c3277d1d.svg";